/**
 * Constants related to pagination and loading behavior
 */

// Maximum number of empty batches to load when filtering for half-price products
export const MAX_EMPTY_HALF_PRICE_BATCHES = 20;
